module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('router-link', {
    attrs: {
      "to": _vm.route,
      "tag": "li"
    }
  }, [_c('a', [(!!_vm.icon) ? _c('span', {
    staticClass: "iconfont",
    class: ("icon-" + _vm.icon)
  }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _vm._t("label")], true), _vm._v(" "), _vm._t("menu")], true)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-6b9ce771!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/comp/slot/smenuli.vue
// module id = 323
// module chunks = 2